import { render, staticRenderFns } from "./refundDepositFeeList.vue?vue&type=template&id=a0fffa7e&scoped=true"
import script from "./refundDepositFeeList.vue?vue&type=script&lang=js"
export * from "./refundDepositFeeList.vue?vue&type=script&lang=js"
import style0 from "./refundDepositFeeList.vue?vue&type=style&index=0&id=a0fffa7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fffa7e",
  null
  
)

export default component.exports